
var $ad3e23d0d86551d9$exports = {};
$ad3e23d0d86551d9$exports = import.meta.resolve("2M23u");


var $6dfdeadaa7717e92$exports = {};
$6dfdeadaa7717e92$exports = import.meta.resolve("9qTXs");


var $d9ce2ca22e070b39$exports = {};
$d9ce2ca22e070b39$exports = import.meta.resolve("y8J5s");


var $6f3e861314fb7ca0$exports = {};
$6f3e861314fb7ca0$exports = import.meta.resolve("axw3Y");


var $01d2cdba02c1a656$exports = {};
$01d2cdba02c1a656$exports = import.meta.resolve("1xtRP");


var $5a3d03bf49706c18$exports = {};
$5a3d03bf49706c18$exports = import.meta.resolve("7aH6P");


var $2b6e161c9edcf319$var$frames = [
    new URL($ad3e23d0d86551d9$exports).href,
    new URL($6dfdeadaa7717e92$exports).href,
    new URL($d9ce2ca22e070b39$exports).href,
    new URL($6f3e861314fb7ca0$exports).href,
    new URL($01d2cdba02c1a656$exports).href,
    new URL($5a3d03bf49706c18$exports).href
];
// Speed curve: slow start, speed up, slow landing on the logo
var $2b6e161c9edcf319$var$timing = [
    600,
    420,
    280,
    220,
    350,
    500 // frame 6 — settle on the logo
];
function $2b6e161c9edcf319$var$preloadFrames(callback) {
    var remaining = $2b6e161c9edcf319$var$frames.length;
    $2b6e161c9edcf319$var$frames.forEach(function(src) {
        var img = new Image();
        img.onload = img.onerror = done;
        img.src = src;
        if (img.complete) done();
    });
    function done() {
        remaining--;
        if (remaining <= 0) callback();
    }
}
function $2b6e161c9edcf319$var$runAnimation() {
    var sprite = document.getElementById("sprite");
    var subtitle = document.querySelector(".subtitle");
    sprite.classList.remove("visible", "heartbeat");
    subtitle.classList.remove("visible");
    $2b6e161c9edcf319$var$preloadFrames(function() {
        var currentFrame = 0;
        sprite.src = $2b6e161c9edcf319$var$frames[0];
        sprite.classList.add("visible");
        function nextFrame() {
            currentFrame++;
            if (currentFrame >= $2b6e161c9edcf319$var$frames.length) {
                sprite.src = $2b6e161c9edcf319$var$frames[$2b6e161c9edcf319$var$frames.length - 1];
                sprite.classList.add("heartbeat");
                setTimeout(function() {
                    subtitle.classList.add("visible");
                }, 500);
                return;
            }
            sprite.src = $2b6e161c9edcf319$var$frames[currentFrame];
            setTimeout(nextFrame, $2b6e161c9edcf319$var$timing[currentFrame]);
        }
        setTimeout(nextFrame, $2b6e161c9edcf319$var$timing[0]);
    });
}
document.addEventListener("DOMContentLoaded", $2b6e161c9edcf319$var$runAnimation);


//# sourceMappingURL=pulse.9b34e6ca.js.map
